"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreModule = void 0;
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var events_1 = require("./events");
exports.CoreModule = new inversify_1.ContainerModule(function (bind) {
    bind(interfaces_1.TypesCore.gameConfig).toConstantValue({ id: "unset", sid: "unset" });
    bind(interfaces_1.TypesCore.dispatcher).to(events_1.EventDispatcher).inSingletonScope();
    bind(interfaces_1.TypesCore.eventProvider).to(events_1.GlobalEventProvider);
});
//# sourceMappingURL=CoreModule.js.map